export default {
  title: 'Order No. {{number}}',
  labels: {
    item: '{{count}} item',
    item_other: '{{count}} items',
  },
  buttons: {
    details: 'Details',
  },
  fulfillment_statuses: {
    created: 'Created',
    reviewed: 'Reviewed',
    accepted: 'Accepted',
    preparing: 'Preparing',
    ready: 'Ready',
    on_delivery: 'On delivery',
    picked: 'Picked',
    rejected: 'Rejected',
  },
};
